import { useEffect, useMemo, useState } from "react";
import EvuCreate from "./EvuCreate";
import EvuUpdate from "./EvuUpdate";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import { evuHeader } from "../Tabellen/ConstTabKopf/EvuKopf";
import StammdatenExport from "../Stammdaten/StammdatenExport";

export default function EvuLaden({ instance }) {
    const [data, setData] = useState();
    const [columns, setColumns] = useState();

    useEffect(() => {
        instance.getEvuEisenbahnverkehrsunternehmenGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setData(data);
                setColumns(evuHeader);
            }
        });
    }, [instance])

    const reloadData = () => {
        setData();
        let loading = new Promise((result) => {
            instance.getEvuEisenbahnverkehrsunternehmenGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    result(data);
                }
            });
        })
        loading.then(d => setData(d))
    }

    const prepData = useMemo(() => data, [data]);
    const additionalColumn =
    {
        id: "update",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => (
            <div>
                <EvuUpdate rowEntry={row} reloadData={reloadData} instance={instance} />
            </div>
        )
    }
    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Eisenbahnverkehrsunternehmen: it.evu,
            Abkürzung: it.kurz
        }))
    }

    return (
        <div>
            <EvuCreate instance={instance} reloadData={reloadData} />
            {data && columns
                ? <div>
                    <GeneralTable data={prepData} columns={columns} hiddenColumns={['id']} additionalColumns={[additionalColumn]} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={['Eisenbahnverkehrsunternehmen', 'Abkürzung']} csvFilename={"sd_evu"} />
                </div>
                : <DatenLaden />}
        </div>
    );

}